import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DSRequestFormService from '../../../../services/DSRequestForm.service';

const DataSubjectType = ({ dsType, getDs, isUsedInventory, domainId }) => {
    const { t } = useTranslation();
    const [formDs] = Form.useForm();

    const [openDataSubject, setOpenDataSubject] = useState(false);
    const [errorMsg, setErrorMsg] = useState();

    const validator = (_, value) => {
        if (dsType.find((d) => d.nameTh === value)) {
            return Promise.reject(new Error(t('dataFlow.ValueExist')));
        }
        if (value) {
            return Promise.resolve();
        }
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const onSaveDataSubject = async (values) => {
        const payload = {
            domainId,
            dataSubjectAddOnName: values.dataSubjectAddOnName,
        };
        try {
            const { data } = await DSRequestFormService.addDataSubject(payload);
            if (data?.resultCode === 1) {
                getDs();
                setOpenDataSubject(false);
                formDs.resetFields();
            } else if (data?.errorData) {
                await setErrorMsg(data?.errorData?.msg);
                await formDs.validateFields();
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Form.Item
            className="mb-0"
            name={['customizeForm', 'dataSubjectType']}
            rules={[
                {
                    required: true,
                    message: t('errorText.requiredField'),
                },
            ]}
        >
            <Checkbox.Group className="w-full">
                {dsType?.map((dsType) => (
                    <div key={dsType?.id}>
                        <Checkbox
                            key={dsType?.id}
                            value={dsType?.id}
                            style={{ lineHeight: '32px' }}
                        >
                            {dsType?.nameTh}
                        </Checkbox>
                    </div>
                ))}
                {openDataSubject && (
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        form={formDs}
                        layout="inline"
                        onFinish={onSaveDataSubject}
                        className="mt-4"
                    >
                        <div>
                            <Form.Item
                                shouldUpdate={
                                    errorMsg === 'DUPLICATE DATA SUBJECT NAME'
                                }
                                // noStyle
                                style={{ marginBottom: 15 }}
                                name="dataSubjectAddOnName"
                                rules={[{ validator }]}
                            >
                                <Input
                                    onChange={() => {
                                        setErrorMsg();
                                    }}
                                    placeholder={t('dataFlow.inputpl')}
                                    maxLength={100}
                                    size="large"
                                />
                            </Form.Item>
                            <Form.Item>
                                <div className="flex items-center">
                                    <Button
                                        type="link"
                                        htmlType="reset"
                                        onClick={() => {
                                            setOpenDataSubject(false);
                                            formDs.resetFields();
                                        }}
                                        className="text-[#95A0A8] pl-0"
                                    >
                                        {t('Cancel')}
                                    </Button>
                                    <Button
                                        onClick={() => formDs.submit()}
                                        type="link"
                                        className="text-[#1890FF]"
                                    >
                                        {t('Save')}
                                    </Button>
                                </div>
                            </Form.Item>
                        </div>
                    </Form>
                )}
                {!isUsedInventory && !openDataSubject && (
                    <button
                        onClick={() => {
                            setOpenDataSubject(true);
                        }}
                        className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold mt-2"
                    >
                        <PlusCircleOutlined /> {t('common.addOption')}
                    </button>
                )}
            </Checkbox.Group>
        </Form.Item>
    );
};

export default DataSubjectType;
